// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/hero_image.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CRIO_SOLUTION_START_MODULE_LOGIN */
/* CRIO_SOLUTION_END_MODULE_LOGIN */
.content {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    justify-content: center;
    height: 70vh;
}

.form {
    background-color: white;
    border-radius: 10px;
    padding: 2rem;
    min-width: 80%;
    margin: 2rem;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
}

.title {
    color: #00a278;
}

.secondary-action {
    padding: 1rem 0;
}

.link {
    font-weight: 700;
    text-decoration: none;
}

.link:focus {
    color: #00a278;
}

.link:active {
    color: #45c09f;
}

.link:visited {
    color: #45c09f;
}

.button {
    background-color: #00a278 !important;
}

.button:hover {
    background-color: #00845c !important;
}

@media screen and (min-width: 768px) {
    .content {
        justify-content: flex-end;
    }
    .form {
        min-width: 24rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Login.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC,mCAAmC;AACnC;IACI,yDAAiD;IACjD,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,YAAY;IACZ,+CAA+C;AACnD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI;QACI,yBAAyB;IAC7B;IACA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":["/* CRIO_SOLUTION_START_MODULE_LOGIN */\n/* CRIO_SOLUTION_END_MODULE_LOGIN */\n.content {\n    background-image: url(\"../assets/hero_image.png\");\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n    display: flex;\n    justify-content: center;\n    height: 70vh;\n}\n\n.form {\n    background-color: white;\n    border-radius: 10px;\n    padding: 2rem;\n    min-width: 80%;\n    margin: 2rem;\n    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);\n}\n\n.title {\n    color: #00a278;\n}\n\n.secondary-action {\n    padding: 1rem 0;\n}\n\n.link {\n    font-weight: 700;\n    text-decoration: none;\n}\n\n.link:focus {\n    color: #00a278;\n}\n\n.link:active {\n    color: #45c09f;\n}\n\n.link:visited {\n    color: #45c09f;\n}\n\n.button {\n    background-color: #00a278 !important;\n}\n\n.button:hover {\n    background-color: #00845c !important;\n}\n\n@media screen and (min-width: 768px) {\n    .content {\n        justify-content: flex-end;\n    }\n    .form {\n        min-width: 24rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
